import { Text } from '@instamenu/ui-system-next';
import type { PaymentMethod } from '@instamenu/context-user';
import { PaymentMethodBrand } from '../payment-method-brand/payment-method-brand';
import { HTMLAttributes } from 'react';

export type PaymentMethodCardProps = {
  paymentMethod: Partial<Pick<PaymentMethod, 'brand' | 'last4'>>;
  selected?: boolean;
  setSelectedPaymentMethodId?: React.Dispatch<React.SetStateAction<string | undefined>>;
} & HTMLAttributes<HTMLDivElement>;

export function PaymentMethodCard(props: PaymentMethodCardProps) {
  const { paymentMethod, children, ...rest } = props;
  return (
    <div
      data-id="payment-method"
      style={{
        display: 'flex',
        alignItems: 'center',
      }}
      {...rest}
    >
      <PaymentMethodBrand brand={paymentMethod.brand || 'unknown'} />
      <div style={{ paddingLeft: 12, display: 'flex', alignItems: 'center' }}>
        <Text variant="caption1">•• {paymentMethod.last4}</Text>
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>{children}</div>
    </div>
  );
}
